
























// @ts-ignore
import { singleErrorExtractorMixin } from 'vuelidate-error-extractor'
import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'

@Component({
  components: { Icon },
  props: {
    errClass: {
      type: String
    },
    fixedHeight: {
      type: Boolean,
      default: true
    }
  },
  mixins: [singleErrorExtractorMixin]
})
export default class InputValidator extends Vue {

}
